// Persisted flag for the Meetings-panel onboarding example state (STARB-4361).
// Once the onboarding is retired — the user dismisses it via the ✕, or a real
// recorded meeting appears — this is set to `'true'` and the example never shows
// again (the panel falls through to the empty state). Per-user, server-side,
// cross-device.
export const MEETINGS_ONBOARDING_RETIRED_KEY = 'meetings-onboarding:retired';

// Persisted numeric contentId of the example "Meeting notes" Confluence page
// (STARB-4362). The page is lazily created once — in the user's personal space,
// on the first Meeting notes / Discuss click — and its id is stored here so
// subsequent clicks reuse the same page instead of creating duplicates.
// Per-user, server-side, cross-device.
export const MEETINGS_ONBOARDING_NOTES_CONTENT_ID_KEY = 'meetings-onboarding:notesContentId';

// Persisted list (JSON-encoded string array) of the example action-item ids the
// user has accepted/clicked through (STARB-4650). Kept so an accepted item stays
// checked across refresh instead of reverting to pending — matching the
// cross-device persistence of the other onboarding signals. Only read/written
// before retirement (once retired the onboarding never renders again).
export const MEETINGS_ONBOARDING_ACCEPTED_ACTIONS_KEY = 'meetings-onboarding:acceptedActions';

export const MeetingsOnboardingKeys: readonly [
	'meetings-onboarding:retired',
	'meetings-onboarding:notesContentId',
	'meetings-onboarding:acceptedActions',
] = [
	MEETINGS_ONBOARDING_RETIRED_KEY,
	MEETINGS_ONBOARDING_NOTES_CONTENT_ID_KEY,
	MEETINGS_ONBOARDING_ACCEPTED_ACTIONS_KEY,
] as const;
